var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGifts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 106,
    viewBox: "0 0 112 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.583 31.9863H7.41667C4.97741 31.9863 3 33.9637 3 36.403V54.0697C3 56.5089 4.97741 58.4863 7.41667 58.4863H104.583C107.023 58.4863 109 56.5089 109 54.0697V36.403C109 33.9637 107.023 31.9863 104.583 31.9863Z",
    stroke: "#C71002",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.167 58.4883V98.2383C100.167 99.4097 99.702 100.533 98.8737 101.361C98.0454 102.19 96.922 102.655 95.7506 102.655H16.2507C15.0793 102.655 13.9559 102.19 13.1276 101.361C12.2993 100.533 11.834 99.4097 11.834 98.2383V58.4883",
    stroke: "#C71002",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56 31.9863V102.653",
    stroke: "#C71002",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0094 25.7482C74.7156 31.9868 56 31.9868 56 31.9868C56 31.9868 56 13.2712 62.2385 6.97741C64.7277 4.48824 68.1037 3.08984 71.624 3.08984C75.1442 3.08984 78.5202 4.48824 81.0094 6.97741C83.4985 9.46658 84.8969 12.8426 84.8969 16.3628C84.8969 19.883 83.4985 23.2591 81.0094 25.7482Z",
    stroke: "#C71002",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9911 25.7482C37.2848 31.9868 56.0005 31.9868 56.0005 31.9868C56.0005 31.9868 56.0005 13.2712 49.7619 6.97741C47.2727 4.48824 43.8967 3.08984 40.3765 3.08984C36.8563 3.08984 33.4802 4.48824 30.9911 6.97741C28.5019 9.46658 27.1035 12.8426 27.1035 16.3628C27.1035 19.883 28.5019 23.2591 30.9911 25.7482Z",
    stroke: "#C71002",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifts);
export default __webpack_public_path__ + "static/media/gifts.70633bfa745de1eaa624243119d23f49.svg";
export { ForwardRef as ReactComponent };